import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconMobile', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M5.6 12.8H10.4V3.2H5.6V12.8ZM8 12C8.4424 12 8.8 11.6424 8.8 11.2C8.8 10.7576 8.4424 10.4 8 10.4C7.5576 10.4 7.2 10.7576 7.2 11.2C7.2 11.6424 7.5576 12 8 12M11.2 1.6H4.8C4.3576 1.6 4 1.9576 4 2.4V13.6C4 14.0424 4.3576 14.4 4.8 14.4H11.2C11.6424 14.4 12 14.0424 12 13.6V2.4C12 1.9576 11.6424 1.6 11.2 1.6V1.6Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M7 16H13V4H7V16ZM10 15C10.553 15 11 14.553 11 14C11 13.447 10.553 13 10 13C9.447 13 9 13.447 9 14C9 14.553 9.447 15 10 15M14 2H6C5.447 2 5 2.447 5 3V17C5 17.553 5.447 18 6 18H14C14.553 18 15 17.553 15 17V3C15 2.447 14.553 2 14 2V2Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M8.4 19.2H15.6V4.8H8.4V19.2ZM12 18C12.6636 18 13.2 17.4636 13.2 16.8C13.2 16.1364 12.6636 15.6 12 15.6C11.3364 15.6 10.8 16.1364 10.8 16.8C10.8 17.4636 11.3364 18 12 18M16.8 2.4H7.2C6.5364 2.4 6 2.9364 6 3.6V20.4C6 21.0636 6.5364 21.6 7.2 21.6H16.8C17.4636 21.6 18 21.0636 18 20.4V3.6C18 2.9364 17.4636 2.4 16.8 2.4V2.4Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M11.2 25.6H20.8V6.4H11.2V25.6ZM16 24C16.8848 24 17.6 23.2848 17.6 22.4C17.6 21.5152 16.8848 20.8 16 20.8C15.1152 20.8 14.4 21.5152 14.4 22.4C14.4 23.2848 15.1152 24 16 24M22.4 3.2H9.6C8.7152 3.2 8 3.9152 8 4.8V27.2C8 28.0848 8.7152 28.8 9.6 28.8H22.4C23.2848 28.8 24 28.0848 24 27.2V4.8C24 3.9152 23.2848 3.2 22.4 3.2V3.2Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));